type CachedNode<Result> = {
  inputs: unknown[];
  result: Result;
};

function haveSameInputs(previous: unknown[], next: unknown[]): boolean {
  return (
    previous.length === next.length &&
    previous.every((input, index) => Object.is(input, next[index]))
  );
}

export function memoizeByNode<
  Node extends { id: string },
  Dependencies extends unknown[],
  Result,
>(
  createNode: (node: Node, ...dependencies: Dependencies) => Result
): (node: Node, ...dependencies: Dependencies) => Result {
  const cache = new Map<string, CachedNode<Result>>();

  return (node, ...dependencies) => {
    const inputs = [node, ...dependencies];
    const cached = cache.get(node.id);

    if (cached && haveSameInputs(cached.inputs, inputs)) {
      return cached.result;
    }

    const result = createNode(node, ...dependencies);

    cache.set(node.id, { inputs, result });

    return result;
  };
}
